import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { routes } from '../../setup/config'
import { useDispatch } from 'react-redux'
import { login } from './actions';

const AuthSuccessPage: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  
  // Extract access token from URL params
  const accessToken = new URLSearchParams(location.search).get('accessToken') || 
                     location.pathname.split('/').pop() || ''

  useEffect(() => {
    if (accessToken) {
      login(accessToken)(dispatch)
    }
  }, [accessToken, dispatch])

  return (
    <Navigate to={routes.dashboardPage} replace />
  )
}

export default AuthSuccessPage
